import { useEffect, useState } from 'react';
import useModalStore from '../../../zustand/store/useModalStore';
import { useShallow } from 'zustand/shallow';
import ConfirmModal from '../../../component/common/modal/ConfirmModal';
import JoinStep1 from './JoinStep1';
import JoinStep2 from './JoinStep2';
import JoinStep3 from './JoinStep3';
import JoinStep4 from './JoinStep4';
import { useIs17Inch } from '../../../hooks/useBreakPoint';

import '../../../css/join.css';
import * as Theme from '../../../images/icons/icons_theme';

const JoinPage = () => {

    // notice modal
    const [notiModal, confirmModal] = useModalStore(
        useShallow((state) => [state.notiModal, state.confirmModal]));

    const [loginStep, setLoginStep] = useState(1);

    const stepComponents = {1: JoinStep1, 2: JoinStep2, 3: JoinStep3, 4: JoinStep4};
    const StepComponent = stepComponents[loginStep];

    const notice = {
        1: '회원가입을 위해 아래 이용약관, 회원정보 수집 및 이용에 대한 안내를 읽고 동의해 주세요.',
        2: '본인확인을 위한 인증방식을 선택해 주세요.',
        3: '기본 정보 및 추가 정보를 입력해 주세요.',
        4: '환영합니다!'
    }

    const [joinInfo, setJoinInfo] = useState({
        userName: '', 
        userIpinDi: '',
        userIpinCi: '',
        userCertDate: ''
    })
    
    const is17Inch = useIs17Inch();
    
    return (
        <div className='main_container'>
            <div className='join_container'>
                <div className='flex flex-col gap-5'>
                    <div className='flex flex-col items-center'>
                        <h2>회원가입</h2>
                        <strong>
                            {notice[loginStep]}
                        </strong>
                    </div>
                    <div className={`flex flex-1 ${is17Inch ? 'gap-6' : 'gap-10'}`}>
                        <div className='flex flex-col gap-5'>
                            {[1,2,3,4].map((step, idx) => {
                                const StepIcon = Theme[`Step${step}`];
                                const stepTitles = {1: '약관동의', 2: '본인확인', 3: '가입정보입력', 4: '가입완료'}
                                return (
                                    <div key={idx} className='flex gap-2'>
                                        <StepIcon className={`step_img_media_set ${loginStep === step ? 'co_black' : 'co_light'}`} />
                                        <div className='content-center'>
                                            <p className={`text-xs ${loginStep !== step ? 'co_light' : 'co_dark'}`}>STEP {step}</p>
                                            <h5 className={`w-fit whitespace-no-wrap ${loginStep !== step ? 'co_light' : ''}`}>
                                                {stepTitles[step]}
                                            </h5>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <hr className='h-full border-l' />
                        {StepComponent &&
                            <StepComponent
                                setLoginStep={setLoginStep}
                                joinInfo={joinInfo}
                                setJoinInfo={setJoinInfo}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JoinPage;